<template>
  <div id="application">
    <header id="header" class="section">
      <div class="container is-max-widescreen">
        <div class="columns is-mobile mb-0">
          <div class="column is-half has-text-left">
            <a href="">
              <img
                  src="../assets/img/istobal-logo.png"
                  :alt="$t('general.istobal-logo')"
              > {{aspectRadio}}
            </a>
          </div>
          <div class="column is-4 is-offset-2 has-text-right">
            <b-dropdown
              v-model="$i18n.locale"
              position="is-bottom-left"
              append-to-body
              aria-role="list">
              <template #trigger>
                  <a
                      class="navbar-item language pr-0"
                      role="button">
                    <b-icon
                        pack="fas"
                        icon="globe"
                        size="is-small">
                    </b-icon>
                    <span class="lang">{{$i18n.locale.toUpperCase()}}</span>
                  </a>
              </template>
              <b-dropdown-item aria-role="listitem" v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
                {{lang.toUpperCase()}}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </header>
    <section id="configurador" class="columns is-vcentered is-mobile is-multiline" v-bind:class="[aspectRadio, { fijo: fijarPuente }]">
      <div class="column">
        <div class="columns is-mobile">
          <div class="column is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only is-1-widescreen has-background-white"></div>
          <div class="column is-full-mobile is-full-tablet is-8-desktop is-8-widescreen c1" v-bind:class="[aspectRadio]">
            <div class="columns is-vcentered is-mobile is-multiline m-0">
              <div id="menu-partes-desktop" class="column is-full-desktop is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only has-background-white has-text-centered is-hidden">
                <div class="menu">
                  <div class="scrolling-wrapper">
                      <div class="opcion viewed">
                        <b-button>Estructura</b-button>
                      </div>
                      <div class="opcion viewed">
                        <b-button @click="scrollTo('carenado')">Carenado</b-button>
                      </div>
                      <div class="opcion">
                        <b-button disabled @click="scrollTo('cabuts')">Cabuts</b-button>
                      </div>
                      <div class="opcion">
                        <b-button @click="scrollTo('puertas')">Puertas</b-button>
                      </div>
                      <div class="opcion">
                        <b-button @click="scrollTo('cepillos')">Cepillos</b-button>
                      </div>
                      <div class="opcion">
                        <b-button @click="scrollTo('lavarruedas')">Lavarruedas</b-button>
                      </div>
                      <div class="opcion selected">
                        <b-button @click="scrollTo('luminosos')">Luminosos</b-button>
                      </div>
                      <div class="opcion">
                        <b-button @click="scrollTo('pictogramas')">Pictogramas</b-button>
                      </div>
                  </div>
                </div>
              </div>
              <div id="menu-mobile" class="column is-10-mobile is-10-tablet is-12-desktop pr-0 has-text-centered">
                <b-button
                  class="has-text-weight-bold pt-0 maquina-seleccionada"
                  @click="isMenuModalActive = true">
                  M'START
                  <b-icon
                      pack="fas"
                      icon="sort-down"
                      size="is-medium"
                      class="ml-1 is-hidden-desktop">
                  </b-icon>
                </b-button>
                <b-button
                  class="has-text-weight-bold pt-0 maquina-seleccionada is-hidden-mobile is-hidden-tablet-only"
                  @click="isComponentModalActive = true"
                  type="is-ghost">
                  <b-icon
                      pack="fas"
                      icon="info-circle"
                      size="is-small">
                  </b-icon>
                </b-button>
              </div>
              <div class="info column is-2 has-text-right is-hidden-desktop">
                <b-button
                  class="has-text-weight-bold pt-0 maquina-seleccionada"
                  @click="isComponentModalActive = true"
                  type="is-ghost">
                  <b-icon
                      pack="fas"
                      icon="info-circle"
                      size="is-small">
                  </b-icon>
                </b-button>
              </div>
              <div id="puente-configurado" class="column is-full p-0">
                <b-carousel
                  :interval=6000 
                  repeat
                  has-drag
                  animated="slide"
                  :autoplay=false
                >
                    <b-carousel-item>
                        <div class="hero">
                            <div class="hero-body p-0 has-text-centered">
                              <img
                                  src="../assets/img/M1_frontal-maquetacion.jpg"
                                  alt="M1 Front"
                              >
                            </div>
                        </div>
                    </b-carousel-item>
                    <b-carousel-item>
                        <div class="hero">
                            <div class="hero-body p-0 has-text-centered">
                              <img
                                  src="../assets/img/M1_trasera-maquetacion.jpg"
                                  alt="M1 Front"
                              >
                            </div>
                        </div>
                    </b-carousel-item>
                </b-carousel>
              </div>
            </div>
          </div>
          <div class="column is-hidden-mobile is-hidden-tablet-only is-4-desktop is-3-widescreen">
            <div class="columns is-mobile is-multiline">
              <div class="column is-full" v-bind:class="[!numPuentesMenuMasSeis ? 'is-hidden' : '']">
                <div id="compartir" class="section lateral">
                  <div class="columns is-vcentered is-mobile is-multiline">
                    <div class="column is-half pb-0">
                      <b-button type="is-rojo"
                        size="is-medium"
                        icon-left="share-variant"
                        expanded
                        @click="isCompartirModalActive = true">
                        Compartir
                      </b-button>
                    </div>
                    <div class="column is-half pb-0">
                      <b-button type="is-verde"
                        size="is-medium"
                        icon-left="email-outline"
                        expanded
                        @click="isAyudaModalActive = true">
                        Contactar
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="sidebar" class="column is-hidden-mobile is-hidden-tablet-only is-full">
                <div id="elementos-configurables" class="column is-full px-0">
                  <div class="detalles column is-full px-0 pt-0">
                  <div id="configuraciones" class="tab-detalle has-text-left">
                    <h3 class="has-text-weight-bold is-red is-uppercase">Configuraciones estándard iQuote</h3>
                    <div class="scrolling-wrapper">
                        <div class="opcion">
                          <b-button>
                            <p class="imagen has-text-centered">
                              <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                            </p>
                            <p class="texto">Un color</p>
                          </b-button>
                        </div>
                        <div class="opcion selected">
                          <b-button>
                            <p class="imagen has-text-centered">
                              <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                            </p>
                            <p class="texto">2A</p>
                          </b-button>
                        </div>
                        <div class="opcion">
                          <b-button>
                            <p class="imagen has-text-centered">
                              <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                            </p>
                            <p class="texto">2B</p>
                          </b-button>
                        </div>
                        <div class="opcion">
                          <b-button>
                            <p class="imagen has-text-centered">
                              <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                            </p>
                            <p class="texto">2C</p>
                          </b-button>
                        </div>
                        <div class="opcion">
                          <b-button>
                            <p class="imagen has-text-centered">
                              <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                            </p>
                            <p class="texto">2D</p>
                          </b-button>
                        </div>
                        <div class="opcion">
                          <b-button>
                            <p class="imagen has-text-centered">
                              <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                            </p>
                            <p class="texto">2E</p>
                          </b-button>
                        </div>
                    </div>
                    <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
                    <div class="colores has-text-left">
                      <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">1</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
                      <b-button type="is-RAL5004" @click="isColoresCarenadoModalActive = true">2</b-button> <p @click="isColoresCarenadoModalActive = true">RAL5004</p>
                    </div>
                  </div>
                    <div id="estructura" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">Estructura</h3>
                      <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
                      <div class="colores has-text-left">
                        <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
                      </div>
                    </div>
                    <div id="carenado" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">Carenado</h3>
                      <div class="scrolling-wrapper">
                          <div class="opcion">
                            <b-button>Plano</b-button>
                          </div>
                          <div class="opcion selected">
                            <b-button>Rocket</b-button>
                          </div>
                      </div>
                      <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
                      <div class="colores has-text-left">
                        <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true" class="with-help">RAL9016<span><br /><em title="Color del carenado delantero central">Central</em></span></p>
                        <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true" class="with-help">RAL9016<span><br /><em title="Color del carenado posterior">Posterior</em></span></p>
                      </div>
                    </div>
                    <div id="cabuts" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">Cabuts</h3>
                      <div class="scrolling-wrapper">
                          <div class="opcion selected">
                            <b-button>Rocket</b-button>
                          </div>
                      </div>
                      <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
                      <div class="colores has-text-left">
                        <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
                      </div>
                    </div>
                    <div id="puertas" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">Puertas</h3>
                      <div class="scrolling-wrapper">
                          <div class="opcion selected">
                            <b-button>Rocket</b-button>
                          </div>
                      </div>
                      <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
                      <div class="colores has-text-left">
                        <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
                      </div>
                    </div>
                    <div id="lavarruedas" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">Lavaruedas
                        <b-field>
                            <b-switch v-model="incluirLavarruedas"
                                true-value="Sí"
                                false-value="No"
                                type="is-primary">
                                {{ incluirLavarruedas }}
                            </b-switch>
                        </b-field>
                      </h3>
                    </div>
                    <div id="luminosos" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">
                      Luminosos
                        <b-field>
                            <b-switch v-model="luminosoIncluir"
                                true-value="Sí"
                                false-value="No"
                                type="is-primary">
                                {{ luminosoIncluir }}
                            </b-switch>
                        </b-field>
                      </h3>
                      <b-field>
                          <b-radio v-model="luminoso"
                              native-value="Semaforo"
                              type="is-primary"
                              disabled>
                              Semáforo
                          </b-radio>
                      </b-field>
                      <b-field>
                          <b-radio v-model="luminoso"
                              native-value="Sferic"
                              type="is-primary"
                              disabled>
                              Semáforo + Sferic
                          </b-radio>
                      </b-field>
                    </div>
                    <div id="pictogramas" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">Pictogramas</h3>
                      <b-field>
                          <b-radio v-model="pictograma"
                              native-value="No"
                              type="is-primary">
                              No
                          </b-radio>
                      </b-field>
                      <b-field>
                          <b-radio v-model="pictograma"
                              native-value="Silver"
                              type="is-primary">
                              Silver
                          </b-radio>
                      </b-field>
                      <b-field>
                          <b-radio v-model="pictograma"
                              native-value="Hexa"
                              type="is-primary">
                              Hexa
                          </b-radio>
                      </b-field>
                    </div>
                    <div id="cepillos" class="tab-detalle has-text-left">
                      <h3 class="has-text-weight-bold is-red is-uppercase">
                        Cepillos
                        <b-field>
                            <b-switch v-model="cepillosTipoSelector"
                                true-value="Selector básico"
                                false-value="Selector avanzado"
                                type="is-primary">
                                {{ cepillosTipoSelector }}
                            </b-switch>
                        </b-field>
                      </h3>
                      <div class="scrolling-wrapper">
                          <div class="opcion">
                            <b-button>Liso</b-button>
                          </div>
                          <div class="opcion">
                            <b-button>Bandas</b-button>
                          </div>
                          <div class="opcion selected">
                            <b-button>Rayado</b-button>
                          </div>
                      </div>
                      <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
                      <div class="colores has-text-left">
                        <b-button type="is-R06" @click="isColoresCepillosModalActive = true">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-GR1">GR1</b-button>
                        <b-button type="is-GR1">GR1</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                        <b-button type="is-R06">R06</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    </section>
    <section id="configurador-2" class="columns is-vcentered is-mobile is-multiline is-hidden-desktop">
      <div id="elementos-configurables" class="column is-full px-0">
        <div class="menu">
          <div class="scrolling-wrapper">
              <div class="opcion viewed">
                <b-button>Estructura</b-button>
              </div>
              <div class="opcion viewed">
                <b-button>Carenado</b-button>
              </div>
              <div class="opcion">
                <b-button disabled>Cabuts</b-button>
              </div>
              <div class="opcion">
                <b-button>Puertas</b-button>
              </div>
              <div class="opcion">
                <b-button>Cepillos</b-button>
              </div>
              <div class="opcion">
                <b-button>Lavarruedas</b-button>
              </div>
              <div class="opcion selected">
                <b-button>Luminosos</b-button>
              </div>
              <div class="opcion">
                <b-button>Pictogramas</b-button>
              </div>
          </div>
        </div>
        <div class="detalles column is-full px-0">
          <div id="configuraciones" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Configuraciones estándard iQuote</h3>
            <div class="scrolling-wrapper">
                <div class="opcion">
                  <b-button>
                    <p class="imagen has-text-centered">
                      <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                    </p>
                    <p class="texto">Un color</p>
                  </b-button>
                </div>
                <div class="opcion selected">
                  <b-button>
                    <p class="imagen has-text-centered">
                      <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                    </p>
                    <p class="texto">2A</p>
                  </b-button>
                </div>
                <div class="opcion">
                  <b-button>
                    <p class="imagen has-text-centered">
                      <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                    </p>
                    <p class="texto">2B</p>
                  </b-button>
                </div>
                <div class="opcion">
                  <b-button>
                    <p class="imagen has-text-centered">
                      <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                    </p>
                    <p class="texto">2C</p>
                  </b-button>
                </div>
                <div class="opcion">
                  <b-button>
                    <p class="imagen has-text-centered">
                      <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                    </p>
                    <p class="texto">2D</p>
                  </b-button>
                </div>
                <div class="opcion">
                  <b-button>
                    <p class="imagen has-text-centered">
                      <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                    </p>
                    <p class="texto">2E</p>
                  </b-button>
                </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">1</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
              <b-button type="is-RAL5004" @click="isColoresCarenadoModalActive = true">2</b-button> <p @click="isColoresCarenadoModalActive = true">RAL5004</p>
            </div>
          </div>
          <div id="estructura" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Estructura</h3>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="carenado" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Carenado</h3>
            <div class="scrolling-wrapper">
                <div class="opcion">
                  <b-button>Plano</b-button>
                </div>
                <div class="opcion selected">
                  <b-button>Rocket</b-button>
                </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="cabuts" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Cabuts</h3>
            <div class="scrolling-wrapper">
                <div class="opcion selected">
                  <b-button>Rocket</b-button>
                </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="puertas" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Puertas</h3>
            <div class="scrolling-wrapper">
                <div class="opcion selected">
                  <b-button>Rocket</b-button>
                </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button> <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="lavarruedas" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Lavaruedas</h3>
            <b-field>
                <b-switch v-model="incluirLavarruedas"
                    true-value="Sí"
                    false-value="No"
                    type="is-primary">
                    {{ incluirLavarruedas }}
                </b-switch>
            </b-field>
          </div>
          <div id="luminosos" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">
            Luminosos
              <b-field>
                  <b-switch v-model="luminosoIncluir"
                      true-value="Sí"
                      false-value="No"
                      type="is-primary">
                      {{ luminosoIncluir }}
                  </b-switch>
              </b-field>
            </h3>
            <b-field>
                <b-radio v-model="luminoso"
                    native-value="Semaforo"
                    type="is-primary"
                    disabled>
                    Semáforo
                </b-radio>
            </b-field>
            <b-field>
                <b-radio v-model="luminoso"
                    native-value="Sferic"
                    type="is-primary"
                    disabled>
                    Semáforo + Sferic
                </b-radio>
            </b-field>
          </div>
          <div id="pictogramas" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Pictogramas</h3>
            <b-field>
                <b-radio v-model="pictograma"
                    native-value="No"
                    type="is-primary">
                    No
                </b-radio>
            </b-field>
            <b-field>
                <b-radio v-model="pictograma"
                    native-value="Silver"
                    type="is-primary">
                    Silver
                </b-radio>
            </b-field>
            <b-field>
                <b-radio v-model="pictograma"
                    native-value="Hexa"
                    type="is-primary">
                    Hexa
                </b-radio>
            </b-field>
          </div>
          <div id="cepillos" class="tab-detalle has-text-left">
            <h3 class="has-text-weight-bold is-red is-uppercase">
              Cepillos
              <b-field>
                  <b-switch v-model="cepillosTipoSelector"
                      true-value="Selector básico"
                      false-value="Selector avanzado"
                      type="is-primary">
                      {{ cepillosTipoSelector }}
                  </b-switch>
              </b-field>
            </h3>
            <div class="scrolling-wrapper">
                <div class="opcion">
                  <b-button>Liso</b-button>
                </div>
                <div class="opcion">
                  <b-button>Bandas</b-button>
                </div>
                <div class="opcion selected">
                  <b-button>Rayado</b-button>
                </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <div v-show="cepillosSelectorSimple" class="simple">
                <b-button type="is-RO6" @click="isColoresCepillosModalActive = true">R06</b-button> <p @click="isColoresCepillosModalActive = true">Color 1</p>
                <b-button type="is-GR1" @click="isColoresCepillosModalActive = true">R06</b-button> <p @click="isColoresCepillosModalActive = true">Color 2</p>
              </div>
              <div v-show="!cepillosSelectorSimple" class="advanced">
                <b-button type="is-R06" @click="isColoresCepillosModalActive = true">R06</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-GR1">GR1</b-button>
                <b-button type="is-GR1">GR1</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-R06">R06</b-button>
                <b-button type="is-R06">R06</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div id="compartir" class="section is-hidden-desktop" v-bind:class="{ fijo: fijarBotonesFooter }">
      <div class="columns is-vcentered is-mobile is-multiline">
        <div class="column is-half">
          <b-button type="is-rojo"
            size="is-medium"
            icon-left="share-variant"
            expanded
            @click="isCompartirModalActive = true">
            Compartir
          </b-button>
        </div>
        <div class="column is-half">
          <b-button type="is-verde"
            size="is-medium"
            icon-left="email-outline"
            expanded
            @click="isAyudaModalActive = true">
            Contactar
          </b-button>
        </div>
      </div>
    </div>
    <section class="section menu-desktop is-hidden-mobile is-hidden-tablet-only" v-bind:class="[aspectRadio]">
      <div class="container is-fluid px-0">
        <div class="columns">
          <div class="column is-8-desktop is-9-widescreen has-text-centered pt-4" v-bind:class="[numPuentesMenuMasSeis ? 'is-12-desktop is-12-widescreen' : '']">
            <div class="menu-maquinas">
              <div class="scrolling-wrapper">
                  <div class="opcion viewed">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      M'1
                    </b-button>
                  </div>
                  <div class="opcion viewed">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      M'Start
                    </b-button>
                  </div>
                  <div class="opcion viewed">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      M'Nex22
                    </b-button>
                  </div>
                  <div class="opcion viewed">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      M'Nex25
                    </b-button>
                  </div>
                  <div class="opcion viewed">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      M'Nex32
                    </b-button>
                  </div>
                  <div class="opcion viewed">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      M'Wash4
                    </b-button>
                  </div>
                  <div class="opcion viewed Puente_Istobal_FLEX5_3">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      Flex5
                    </b-button>
                  </div>
                  <div class="opcion viewed Puente_Istobal_FLEX5_3_Extended">
                    <b-button
                    type="is-ghost">
                      <img
                        src="../assets/img/M22_menu_desktop.jpg"
                        alt="M1 Front"
                      ><br />
                      Flex5 Extended
                    </b-button>
                  </div>
              </div>
            </div>
          </div>
          <div class="column is-4-desktop is-3-widescreen" v-bind:class="[numPuentesMenuMasSeis ? 'is-hidden' : '']">
            <div id="compartir" class="section">
              <div class="columns is-vcentered is-mobile is-multiline">
                <div class="column is-half">
                  <b-button type="is-rojo"
                    size="is-medium"
                    icon-left="share-variant"
                    expanded
                    @click="isCompartirModalActive = true">
                    Compartir
                  </b-button>
                </div>
                <div class="column is-half">
                  <b-button type="is-verde"
                    size="is-medium"
                    icon-left="email-outline"
                    expanded
                    @click="isAyudaModalActive = true">
                    Contactar
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer pb-0" v-bind:class="{ conPadding: fijarBotonesFooter }" v-observe-visibility="visibilityChanged">
      <div class="content has-text-centered">
        <p class="is-size-6">
          <img
            class="logo"
            src="../assets/img/ISTOBAL_Vehicle-Wash-and-Care_b.png"
            alt="ISTOBAL - Vehicle Wash & Care"
            @click="error('Error al cargar la imagen','is-success')"
          ><br />
          Las imágenes, videos e informaciones que aparecen en este espacio son meramente ilustrativos y no vinculantes, pueden ser opcionales o no estar disponibles según el modelo, y no constituyen una oferta. Puede contactar con el departamento comercial de ISTOBAL para cualquier información adicional o solicitud de oferta de nuestros productos.
        </p>
        <p class="copyright is-size-6">© ISTOBAL 2021. Todos los derechos reservados.</p>
      </div>
    </footer>
    <b-modal
        v-model="isComponentModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal
        custom-class="info-puente">
          <div class="card px-6 pb-6">
            <div class="card-image has-text-right">
              <button
              type="button"
              class="delete mt"
              @click="isComponentModalActive = false"/>
            </div>
            <div class="card-content has-text-left pt-0">
                <div class="content pb-2">
                  <h1 class="is-size-5">ISTOBAL M'START</h1>
                  <p>La eficiencia en el lavado es algo más que un concepto, es el resultado de aunar calidad, tecnología y rendimiento en un único diseño.</p>
                  <p>Así es <strong>ISTOBAL M’START</strong>, el puente de lavado desarrollado por <strong>ISTOBAL</strong> que satisface las expectativas de cualquier cliente.</p>
                  <h2 class="is-size-6">Configuraciones estándar iQuote:</h2>
                  <h3 class="is-size-6">Opción 1 color</h3>
                  <ul class="m-0 p-0">
                    <li>
                      <p class="imagen has-text-centered">
                        <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-1.jpg" alt="1 color" />
                      </p>
                    </li>
                  </ul>
                  <h3 class="is-size-6">Opción 2 colores (4 configuraciones)</h3>
                  <ul class="m-0 p-0">
                    <li>
                      <p class="texto">(2A) Estructura. Carenados.</p>
                      <p class="imagen has-text-centered">
                        <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2a.jpg" alt="2 colores: Estructura y carenados" />
                      </p>
                    </li>
                    <li>
                      <p class="texto">(2B) Carenados laterales. Resto de máquina.</p>
                      <p class="imagen has-text-centered">
                        <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2b.jpg" alt="2 colores: Estructura y carenados" />
                      </p>
                    </li>
                    <li>
                      <p class="texto">(2C) Estructura. Carenados.</p>
                      <p class="imagen has-text-centered">
                        <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2c.jpg" alt="2 colores: Estructura y carenados" />
                      </p>
                    </li>
                    <li>
                      <p class="texto">(2D) Estructura. Carenados.</p>
                      <p class="imagen has-text-centered">
                        <img src="https://istobalconfiguradorapi.javiruiz.com/storage/img/flex5-conf-2d.jpg" alt="2 colores: Estructura y carenados" />
                      </p>
                    </li>
                  </ul>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isColoresCepillosModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Selector de colores"
        aria-modal
        custom-class="selector-colores">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris">Seleccionar color</h4>
                  <div class="colores has-text-centered-touch">
                    <b-button type="is-R06">R06</b-button>
                    <b-button type="is-AZL">AZL</b-button>
                    <b-button type="is-AZ2">AZ2</b-button>
                    <b-button type="is-AZ3">AZ3</b-button>
                    <b-button type="is-AZJ">AZJ</b-button>
                    <b-button type="is-VE1">VE1</b-button>
                    <b-button type="is-VE2">VE2</b-button>
                    <b-button type="is-VE3">VE3</b-button>
                    <b-button type="is-VE4">VE4</b-button>
                    <b-button type="is-NA1" focused>NA1</b-button>
                    <b-button type="is-AM5">AM5</b-button>
                    <b-button type="is-GR1">GR1</b-button>
                    <b-button type="is-GR7">GR7</b-button>
                    <b-button type="is-BL1">BL1</b-button>
                    <b-button type="is-MA1">MA1</b-button>
                    <b-button type="is-VI2">VI2</b-button>
                    <b-button type="is-NE1">NE1</b-button>
                  </div>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresCepillosModalActive = false">Cancelar</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isColoresCarenadoModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Selector de colores"
        aria-modal
        custom-class="selector-colores">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris">Seleccionar color</h4>
                  <!--<a class="close has-text-right is-size-7">
                    <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
                  </a>-->
                  <div class="colores has-text-centered">
                    <b-button type="is-RAL9016" focused>RAL9016</b-button>
                    <b-button type="is-RAL9010">RAL9010</b-button>
                    <b-button type="is-RAL9003">RAL9003</b-button>
                    <b-button type="is-RAL9018">RAL9018</b-button>
                    <b-button type="is-RAL1013">RAL1013</b-button>
                    <b-button type="is-RAL1021">RAL1021</b-button>
                    <b-button type="is-RAL1003">RAL1003</b-button>
                    <b-button type="is-RAL1033">RAL1033</b-button>
                    <b-button type="is-LAVANCE">LAVANCE</b-button>
                    <b-button type="is-RAL2004">RAL2004</b-button>
                    <b-button type="is-RAL3020">RAL3020</b-button>
                    <b-button type="is-RAL3002">RAL3002</b-button>
                    <b-button type="is-RAL5004">RAL5004</b-button>
                    <b-button type="is-RAL5011">RAL5011</b-button>
                    <b-button type="is-P280C">P280C</b-button>
                    <b-button type="is-P293C">P293C</b-button>
                    <b-button type="is-RAL5015">RAL5015</b-button>
                    <b-button type="is-P7468C">P7468C</b-button>
                    <b-button type="is-P299C">P299C</b-button>
                    <b-button type="is-P348C">P348C</b-button>
                    <b-button type="is-P368C">P368C</b-button>
                    <b-button type="is-COOLGRAY1">COOLGRAY1</b-button>
                    <b-button type="is-RAL7035">RAL7035</b-button>
                    <b-button type="is-RAL7032">RAL7032</b-button>
                    <b-button type="is-RAL9006">RAL9006</b-button>
                    <b-button type="is-RAL7040">RAL7040</b-button>
                    <b-button type="is-P424C">P424C</b-button>
                    <b-button type="is-GRISSHELL">GRISSHELL</b-button>
                    <b-button type="is-RAL7022">RAL7022</b-button>
                    <b-button type="is-RAL9005">RAL9005</b-button>
                  </div>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresCarenadoModalActive = false">Cancelar</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isCompartirModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Compartir"
        aria-modal
        custom-class="modal-compartir">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris">Compartir</h4>
                  <!--<a class="close has-text-right is-size-7">
                    <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
                  </a>-->
                  <div class="colores compartir has-text-left">
                    <b-menu>
                      <b-menu-list>
                        <b-menu-item icon="email-outline" label="E-mail"></b-menu-item>
                        <b-menu-item icon="file-pdf-outline" label="Descargar PDF"></b-menu-item>
                        <b-menu-item icon="content-copy" label="Copiar enlace"></b-menu-item>
                      </b-menu-list>
                    </b-menu>
                  </div>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isCompartirModalActive = false">Cancelar</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isAyudaModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Compartir"
        aria-modal
        custom-class="modal-ayuda">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content ayuda pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris mt-1 mb-5">
                    <img
                        src="../assets/img/istobal-logo.png"
                        :alt="$t('general.istobal-logo')"
                    >
                  </h4>
                  <p class="mb-5"><strong>¿Necesitas ayuda?</strong> Contáctanos y uno de nuestros profesionales te asesorará</p>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="llamar()">Llamar +34 96 111 10 20</b-button>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isCompartirModalActive = false;isContactoModalActive = false">Solicitar más información</b-button>
                  <b-button type="is-ghost" expanded class="salir py-4 is-size-5" @click="isAyudaModalActive = false">Salir</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isPrevenirSalidaModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Seguro"
        aria-modal
        custom-class="modal-ayuda">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content ayuda prevenir pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris mt-1 mb-5">
                    <img
                        src="../assets/img/istobal-logo.png"
                        :alt="$t('general.istobal-logo')"
                    >
                  </h4>
                  <p class="mb-5">Seleccione qué prefiere hacer con el puente de lavado que ha configurado</p>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isPrevenirSalidaModalActive = false;isCompartirModalActive = true">Compartir o guardar</b-button>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5"  @click="isPrevenirSalidaModalActive = false;isContactoModalActive = true">Solicitar más información</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isMenuModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Menú"
        aria-modal
        custom-class="puentes-disponibles">
          <div class="container has-text-left">
            <div class="section pt-0">
              <div class="columns is-mobile is-multiline">
                <div class="column is-full">
                  <h2 class="is-size-5 has-text-weight-bold">CONFIGURADOR</h2>
                  <p>Seleccione uno de los puentes de lavado para configurarlo.</p>
                </div>
                <div class="column is-full">
                  <ul>
                    <li>
                      <div>
                        <div class="foto">                            
                          <a href="" class="nombre is-size-5">ISTOBAL M'START</a>
                          <a href="" class="plus has-text-right is-size-6">
                            <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-plus.svg" alt="seleccionar" /></span>
                          </a>
                          <b-carousel
                            :interval=6000 
                            repeat
                            has-drag
                            animated="slide"
                            :autoplay=false
                          >
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            class="imagerenderf"
                                            src="../assets/img/MSTART-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            class="imagerenderr"
                                            src="../assets/img/MSTART-trasera-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                          </b-carousel>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div>
                        <div class="foto">                            
                          <a href="" class="nombre is-size-5">ISTOBAL M'START</a>
                          <a href="" class="plus has-text-right is-size-6">
                            <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-plus.svg" alt="seleccionar" /></span>
                          </a>
                          <b-carousel
                            :interval=6000 
                            repeat
                            has-drag
                            animated="slide"
                            :autoplay=false
                          >
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-trasera-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                          </b-carousel>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div>
                        <div class="foto">                            
                          <a href="" class="nombre is-size-5">ISTOBAL M'START</a>
                          <a href="" class="plus has-text-right is-size-6">
                            <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-plus.svg" alt="seleccionar" /></span>
                          </a>
                          <b-carousel
                            :interval=6000 
                            repeat
                            has-drag
                            animated="slide"
                            :autoplay=false
                          >
                              <b-carousel-item>
                                  <div class="hero">
                                    <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-menu.jpg"
                                            alt="M1 Front"
                                        >
                                    </div>
                                  </div>
                              </b-carousel-item>
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-trasera-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                          </b-carousel>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div>
                        <div class="foto">                            
                          <a href="" class="nombre is-size-5">ISTOBAL M'START</a>
                          <a href="" class="plus has-text-right is-size-6">
                            <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-plus.svg" alt="seleccionar" /></span>
                          </a>
                          <b-carousel
                            :interval=6000 
                            repeat
                            has-drag
                            animated="slide"
                            :autoplay=false
                          >
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-trasera-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                          </b-carousel>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div>
                        <div class="foto">                            
                          <a href="" class="nombre is-size-5">ISTOBAL M'START</a>
                          <a href="" class="plus has-text-right is-size-6">
                            <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-plus.svg" alt="seleccionar" /></span>
                          </a>
                          <b-carousel
                            :interval=6000 
                            repeat
                            has-drag
                            animated="slide"
                            :autoplay=false
                          >
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                              <b-carousel-item>
                                  <div class="hero">
                                      <div class="hero-body p-0 has-text-centered">
                                        <img
                                            src="../assets/img/MSTART-trasera-menu.jpg"
                                            alt="M1 Front"
                                        >
                                      </div>
                                  </div>
                              </b-carousel-item>
                          </b-carousel>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    </b-modal>
    <b-loading v-model="isLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
export default {
name: "Static",
  data () {
    return { 
      isMenuModalActive: false,
      isComponentModalActive: false,
      isColoresCepillosModalActive: false,
      isColoresCarenadoModalActive: false,
      isCompartirModalActive: false,
      isAyudaModalActive: false,
      isContactoModalActive: false,
      isPrevenirSalidaModalActive: false,
      incluirLavarruedas: 'Sí',
      luminosoIncluir: 'No',
      cepillosTipoSelector: 'Selector básico',
      luminoso: 'Sferic',
      pictograma: 'Silver',
      langs: ['es', 'en'],
      fijarBotonesFooter: false,
      scrollDirection: null,
      scrollYPosition: 0,
      fijarPuente: false,
      isLoading: false,
      aspectRadio: 'aspect_16_9',
      sidebarHeight: 0,
      numPuentesMenuMasSeis: true
    }
  },
  mounted: function() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  created(){
    window.addEventListener("beforeunload", this.preventNav)
  },
  beforeDestroy(){
    window.addEventListener("beforeunload", this.preventNav)
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
     cepillosSelectorSimple: function () {
        if (this.cepillosTipoSelector=='Selector básico') return true;
        else return false;
     }
  },
  methods: {
    llamar(){
      window.location ='tel:0034961111020';
    },
    error(message,type){
      this.$buefy.toast.open({
          duration: 50000,
          message: message,
          type: type
      })
    },
    handleScroll: function() {
      if (window.innerWidth < 769){
        var scrollY = window.scrollY
        var headerHeight = document.getElementById('header').clientHeight;
        var configuradorHeight = document.getElementById('configurador').clientHeight;
        if (scrollY > this.scrollYPosition) {
          this.scrollDirection = 'down';
          this.fijarBotonesFooter = false;
          if (scrollY > headerHeight){
            this.fijarPuente = true;
            document.getElementsByTagName("BODY")[0].style.paddingTop = configuradorHeight + "px";
          }
        } else {
          this.scrollDirection = 'up';
          if (window.innerHeight)
          this.fijarBotonesFooter = true;
          if (scrollY <= headerHeight){
            this.fijarPuente = false;
            document.getElementsByTagName("BODY")[0].style.paddingTop = "0px";
          }
        }
        this.scrollYPosition = scrollY;
      }
    },
    aspectRadioGET (a, b) {
            return (b == 0) ? a : this.aspectRadioGET (b, a%b);
    },
    handleResize() {
      var aspect = this.aspectRadioGET(window.innerWidth,window.innerHeight)
      this.aspectRadio = 'aspect_' + window.innerWidth/aspect + "_" + window.innerHeight/aspect;
      this.sidebarHeight = document.getElementById('sidebar').clientHeight;
      var aspectPersonalizado = ["aspect_512_683","aspect_512_627","aspect_16_9","aspect_4_3","aspect_683_512","aspect_8_5","aspect_683_384","aspect_384_199"]
      if (!aspectPersonalizado.includes(this.aspectRadio)){
        var nuevoAlto = Math.round(this.sidebarHeight*1.2);
        document.getElementsByClassName("myDIV").style.height = nuevoAlto+"px";
        document.getElementById("myDIV").style.width = "100%";
      }else{
         document.getElementById("myDIV").style.height = "auto";
         document.getElementById("myDIV").style.width = "100%";
      }
      //alert(aspect + ' w=' + window.innerWidth + ' h=' + window.innerHeight + ' -> ' + this.aspectRadio);
      alert('Sidebar h=' + this.sidebarHeight + '');
    },
    preventNav(event) {
      //if (this.isPrevenirSalidaModalActive!==true){
        // Cancel the event
        event.preventDefault()
        // Chrome requires returnValue to be set
        this.isPrevenirSalidaModalActive=true;
        event.returnValue = ''
      //}
    },
    visibilityChanged (isVisible, entry) {
      this.isVisible = isVisible
      if (entry.target.nodeName=='FOOTER' && this.isVisible && this.fijarBotonesFooter===true){
        this.fijarBotonesFooter=false;
      }
      console.log(this.isVisible)
      console.log(entry.target.nodeName)
      console.log(entry)
      console.log(this)
    },
    scrollTo(elementID){
      var myElement = document.getElementById(elementID);
      var topPos = myElement.offsetTop - 150;
      document.getElementById('sidebar').scrollTop = topPos;
      //document.getElementById(elementID).scrollIntoView();
    }
  }
}
</script>

<style scoped>

</style>
